import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Table,
  Switch,
  Button,
  Space,
  Tag,
  Avatar,
  Modal,
  Dropdown,
  Menu,
  message,
  Checkbox,
  Form,
  Spin,
  Col,
  Row,
  Badge,
} from "antd";
import {
  LeftOutlined,
  RightOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllDepartmentList,
  getClientid,
  getIsShowAgain,
  getLocations,
  getMenuList,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import { find, startCase, uniqBy } from "lodash";
import COLORS from "common/Colors";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AssignShift from "./AssignShift";
import { style } from "@mui/system";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import DayInfo from "./DayInfo";
import ChangeShift from "./ChangeShift";
import { saveIsShowAgain } from "redux/actions";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { isDateBetweenTwoDates } from "utils/Date";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import CloneShift from "./CloneShift";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

const StyledAvatar = styled(Avatar)`
  margin-left: 10px;
  margin-right: 0.5rem;
  width: 30px;
  height: 30px;
  // margin-bottom: 5px;
  background-color: ${COLORS.PRIMARY};
  vertical-align: middle;
`;

const ShiftCalendarWrap = styled.div`
  .custom-table-row > td {
    height: 100px;
  }
  .ant-table-tbody > tr > td {
    padding: 0px 0px;
  }
  .exporting-pdf {
    width: fit-content !important;
    max-width: unset !important;
    max-height: unset !important;
  }
  .exportpdf {
    width: 100%;
    height: 100%;
  }
  .header-view {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .header-buttons {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .change-view {
    color: #2d53da;
  }
  .change-view:disabled {
    color: #e3e8fc !important;
  }
  .change-view:hover {
    background: #c5cff5;
  }
  .ant-switch {
    background-color: #03c83e;
  }
  small {
    color: #636980;
    font-size: 10px;
    font-weight: 400;
  }
  .past_columns {
    background-color: #fafafa !important;
  }
`;

style.innerHTML = `
  #shift-table-export,
  #shift-table-export *,
  #shift-table-export .ant-table,
  #shift-table-export .ant-table-container,
  #shift-table-export .ant-table-body,
  #shift-table-export .ant-table-content {
    overflow: hidden !important;
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }
  #shift-table-export *::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  #shift-table-export .ant-table-ping-right::after,
  #shift-table-export .ant-table-ping-left::after {
    display: none !important;
  }
`;

const ShiftCalendar = () => {
  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);
  const ClientId = useSelector(getClientid);
  const userInfo = useSelector(getUserInfo);
  const locationList = useSelector(getLocations);
  const [form] = Form.useForm();
  const [isMonthly, setIsMonthly] = useState(false);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  const userLists = useSelector(getUserList);
  const userList = useMemo(
    () => userLists?.filter((user) => user?.statusid === "1"),
    [userLists]
  );
  const filteruser = userList?.filter(
    (item) => item?.userid === userInfo?.userid
  );
  const userTimeZone =
    locationList?.find(
      (val) => val?.location_id === filteruser[0]?.baselocationid
    )?.usertimezone || "Africa/Nairobi";
  const [currentDate, setCurrentDate] = useState(dayjs());
  const departmentList = useSelector(getAllDepartmentList);

  const getShowAgain = useSelector(getIsShowAgain);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const shiftColor = location?.state?.shiftColors || [];
  const [isAssignShift, setIsAssignShift] = useState(false);
  const [isCloneShift, setIsCloneShift] = useState(false);
  const [isChangeShift, setIsChangeShift] = useState(false);
  const [showSelection, setShowSelection] = useState(false);
  const [showColumnSelection, setShowColumnSelection] = useState(false);
  const [assignedColumnSelection, setAssignedColumnSelection] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [selectedCells, setSelectedCells] = useState([]);
  const [selectedType, setSetlectedType] = useState("");
  const [isCardVisible, setIsCardVisible] = useState(false);
  const [cardRecord, setCardRecord] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [exportLoader, setExportLoader] = useState(false);
  const [filterShiftList, setFilterShiftList] = useState([]);
  const [selectedCell, setSelectedCell] = useState({});
  const [assignedShiftList, setAssignedShiftList] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [holidayList, setHolidayList] = useState([]);

  const currentTime = dayjs().tz(userTimeZone).format("HH:mm:ss");

  const shiftMap = useMemo(() => {
    const map = {};
    shiftList.forEach((s) => {
      map[s.shift_id] = s;
    });
    return map;
  }, [shiftList]);

  const assignedShiftMap = useMemo(() => {
    const map = {};
    assignedShiftList.forEach((item) => {
      map[item.userId] = item;
    });
    return map;
  }, [assignedShiftList]);

  const leaveMap = useMemo(() => {
    const map = {};
    leaveList.forEach((l) => {
      if (!map[l.userid]) map[l.userid] = [];
      map[l.userid].push(l);
    });
    return map;
  }, [leaveList]);

  // const findShift = shiftList?.find((val) => val?.shift_id === 94);
  // console.log("shifttime--.", dayjs(findShift?.starts).format("HH:mm:ss"));

  const getHolidayList = async () => {
    const response = await CALL_API(`holiday-list/${ClientId}`, "post", {
      start_date: currentDate.startOf("month").format("YYYY-MM-DD"),
      end_date: currentDate.endOf("month").format("YYYY-MM-DD"),
    });
    setHolidayList(response);
  };

  const containerRef = useRef(null);

  const getShiftList = async () => {
    try {
      const { data } = await CALL_API(`get-shift/${ClientId}`, "get", {});
      setShiftList(data);
    } catch (error) {
      console.log("[getDepartmentList], Error-->", error);
    }
  };

  const getLeaveList = async () => {
    const { code, leaves } = await CALL_API(`leave-list/${ClientId}`, "post", {
      status_id: "4,5",
      department_id: [""],
      selected_role_id: "",
      start_date: currentDate.startOf("month").format("YYYY-MM-DD"),
      end_date: currentDate.endOf("month").format("YYYY-MM-DD"),
      show_my_team_leave: false,
    });
    if (code === STATUS_CODE.SUCCESS) {
      setLeaveList(leaves);
    }
  };

  const handleFormChange = () => {
    const values = form.getFieldsValue();

    if (
      (!values?.department || values.department.length === 0) &&
      (!values?.location || values.location.length === 0) &&
      (!values?.people || values.people.length === 0)
    ) {
      setFilterShiftList(userList);
      return;
    }

    const shiftFilter = userList.filter((user) => {
      const departmentMatch =
        !values.department?.length ||
        values?.department?.includes(user?.basedepartmentid);

      const locationMatch =
        !values.location?.length ||
        values?.location?.includes(user?.baselocationid);
      const peopleMatch =
        !values.people?.length || values?.people?.includes(user?.userid);
      const typeMatch =
        !values.type?.length || values?.type?.includes(user?.employementtype);
      return departmentMatch && locationMatch && peopleMatch && typeMatch;
    });

    setFilterShiftList(shiftFilter);
  };

  const today = dayjs().tz(userTimeZone).startOf("day");

  const handleToggle = (checked) => setIsMonthly(checked);
  const handlePrev = () =>
    setCurrentDate((prev) =>
      isMonthly ? prev.subtract(1, "month") : prev.subtract(1, "week")
    );
  const handleNext = () =>
    setCurrentDate((prev) =>
      isMonthly ? prev.add(1, "month") : prev.add(1, "week")
    );

  const getDates = useMemo(() => {
    const start = isMonthly
      ? currentDate.startOf("month")
      : currentDate.startOf("week");
    const end = isMonthly
      ? currentDate.endOf("month")
      : currentDate.endOf("week");
    const days = [];

    for (
      let date = start;
      date.isBefore(end) || date.isSame(end, "day");
      date = date.add(1, "day")
    ) {
      days.push(date);
    }

    return days;
  }, [isMonthly, currentDate]);

  const handleCancel = () => {
    setSelectedCells([]);
    setSelectedRowKeys([]);
    setSelectedRowIds([]);
    setShowColumnSelection(false);
    setShowSelection(false);
    setAssignedColumnSelection(false);
    setSetlectedType("");
  };

  const getAssignedShiftList = async () => {
    try {
      const { data } = await CALL_API(
        `get-assigned-shift/${ClientId}`,
        "post",
        {
          from: isMonthly
            ? currentDate.startOf("month").format("YYYY-MM-DD")
            : currentDate.startOf("week").format("YYYY-MM-DD"),
          to: isMonthly
            ? currentDate.endOf("month").format("YYYY-MM-DD")
            : currentDate.endOf("week").format("YYYY-MM-DD"),
        }
      );
      setAssignedShiftList(data);
      handleCancel();
    } catch (error) {
      console.log("[getShiftList] Error:", error);
    } finally {
    }
  };

  const days = getDates;

  const dataSource = useMemo(() => {
    console.log("filterShiftList", filterShiftList);
    return filterShiftList.map((user, i) => {
      const emp = {
        key: user.userid,
        fullname: user.fullname,
        employeeid: user.employeeid,
        userid: user.userid,
        profileurl: user.profileurl,
      };

      const userShift = assignedShiftMap[user.userid];
      const userLeaves = leaveMap[user.userid] || [];

      days.forEach((d) => {
        const dateStr = d.format("YYYY-MM-DD");

        const dateShift = userShift?.dates?.find((ds) => ds.date === dateStr);
        const shift = shiftMap[dateShift?.shift_id];

        const leave = userLeaves.find(
          (l) =>
            dateStr >= (l.new_start_date || l.start_date) &&
            dateStr <= (l.new_end_date || l.end_date)
        );

        emp[dateStr] = shift?.shifttitle || null;
        emp[`${dateStr}_id`] = shift?.shift_id || "";
        emp[`${dateStr}_code`] = dateShift?.shiftcode || null;
        emp[`${dateStr}_color`] = userShift?.color || "";
        emp[`${dateStr}_leave_status`] = leave?.status_id || "";
        emp[`${dateStr}_leave_name`] = leave?.leave_category_name || "";
        emp[`${dateStr}_isammended`] = leave?.having_cancel_request || "";
      });

      return emp;
    });
  }, [filterShiftList, days, assignedShiftMap, leaveMap, shiftMap]);

  const handleRemove = async (record, colkey) => {
    try {
      setConfirmLoading(true);
      const { status } = await CALL_API(
        `remove-assigned-shift/${ClientId}`,
        "delete",
        {
          userId: record?.userid,
          date: colkey,
        }
      );

      if (status === STATUS_CODE.SUCCESS) {
        message.success("Shift removed successfully");
        dispatch(
          saveIsShowAgain({ removeShift: form?.getFieldValue("removeshift") })
        );
        getAssignedShiftList();
      } else {
        message.error("Failed to remove shift.");
      }
    } catch (error) {
      message.error("Something went wrong.");
    } finally {
      setConfirmLoading(false);
    }
  };

  const showRemoveConfirm = (record, colkey) => {
    if (getShowAgain?.removeShift) {
      handleRemove(record, colkey);
    } else {
      Modal.confirm({
        title: "Are you sure you want to Remove this Shift?",
        content: (
          <Form
            form={form}
            name="isShowagain"
            layout="vertical"
            initialValues={{ removeshift: getShowAgain?.removeShift }}
          >
            <Form.Item name="removeshift" valuePropName="checked">
              <Checkbox
                disabled={false}
                style={{ color: "#5d5f68", fontWeight: 500 }}
              >
                Don't show this again
              </Checkbox>
            </Form.Item>
          </Form>
        ),
        okText: "Yes, Remove",
        cancelText: "No, Cancel",
        okButtonProps: {
          loading: confirmLoading,
        },
        onOk: async () => {
          handleRemove(record, colkey);
        },
      });
    }
  };
  const handleWarning = () => {
    Modal.warning({
      title: "Shift removed not allowed",
      content:
        "You cannot remove the shift after check-in or once the shift start time has passed.",
      okText: "OK",
    });
  };
  const getMenu = (record, colKey) => (
    <Menu>
      {Menulist?.find(
        (item) =>
          item?.key === "manage" &&
          item?.subMenu.find(
            (subItem) => subItem?.key === "shift" && subItem?.permission.edit
          )
      ) && (
        <Menu.Item
          key="1"
          onClick={() => {
            const cellRecord = {
              userid: record.userid,
              fullname: record.fullname,
              date: colKey,
              shiftId: record[`${colKey}_id`],
              shiftCode: record[`${colKey}_code`],
              leaveStatus: record[`${colKey}_leave_status`],
              shiftTitle: record[`${colKey}`],
            };

            setSelectedCell(cellRecord);
            setIsChangeShift(true);
          }}
        >
          Change Shift
        </Menu.Item>
      )}
      {Menulist?.find(
        (item) =>
          item?.key === "manage" &&
          item?.subMenu.find(
            (subItem) => subItem?.key === "shift" && subItem?.permission.edit
          )
      ) && (
        <Menu.Item
          key="2"
          onClick={() => {
            const findShift = shiftMap[record[`${colKey}_id`]];
            // shiftList?.find(
            //   (val) => val?.shift_id === record?.[`${colKey}_id`]
            // );

            const shiftStartTime = dayjs(findShift?.starts).format("HH:mm:ss");

            // if (
            //   currentTime >= shiftStartTime &&
            //   dayjs().tz(userTimeZone).isSame(dayjs(colKey), "day")
            // ) {
            //   handleWarning();
            // } else {
            //   // ✅ Allowed
            //   showRemoveConfirm(record, colKey);
            // }
            showRemoveConfirm(record, colKey);
          }}
        >
          Remove Shift
        </Menu.Item>
      )}
    </Menu>
  );
  const dateColumnWidth = 180;
  const fixedEmployeeWidth = 180;

  const isRowSelectable = (emp, colKey) => {
    const findShift = shiftMap[emp?.[`${colKey}_id`]];

    const isShiftTimeValid =
      dayjs(findShift?.starts)?.format("HH:mm:ss") < currentTime &&
      colKey === dayjs().tz(userTimeZone).format("YYYY-MM-DD");

    const isPast = dayjs(colKey).isBefore(today, "day");

    return !isPast && !isShiftTimeValid;
  };

  const renderCell = useCallback(
    (value, record, date) => {
      const isPast = dayjs(date).isBefore(today, "day");
      const colKey = date.format("YYYY-MM-DD");
      const findShift = shiftMap[record[`${colKey}_id`]];
      const isShiftTimeValid =
        dayjs(findShift?.starts)?.format("HH:mm:ss") < currentTime &&
        colKey === dayjs().tz(userTimeZone).format("YYYY-MM-DD");
      const baselocationid = userList?.find(
        (val) => val?.userid === record?.userid
      )?.baselocationid;
      const filterHolidayList = holidayList?.filter((item) =>
        item?.location_id?.includes(baselocationid)
      );
      const isHoliday = find(filterHolidayList, ({ start_date, end_date }) =>
        isDateBetweenTwoDates(colKey, start_date, end_date)
      );
      const daynumber = dayjs(colKey).day();
      return (
        <div
          className={
            isShiftTimeValid && value ? "past_columns w-100 p-2" : "p-2"
          }
          style={{ height: "100px" }}
        >
          {
            <div className="w-100 h-100 ms-1 d-flex justify-content-center align-items-center">
              {value || record?.[`${colKey}_leave_status`] || isHoliday ? (
                <Tag
                  style={{
                    background:
                      record?.[`${colKey}_leave_status`] ||
                      (findShift?.isweekend === "allsaturdayandsunday" &&
                        (daynumber === 0 || daynumber === 6)) ||
                      (findShift?.isweekend === "allsaturdays" &&
                        daynumber === 6) ||
                      (findShift?.isweekend === "allsundays" &&
                        daynumber === 0) ||
                      findShift?.isweekend === "alldays" ||
                      (isHoliday && findShift?.isholiday === "no")
                        ? ""
                        : shiftList?.find(
                            (val) => val?.shift_id === record?.[`${colKey}_id`]
                          )?.color || "",
                    borderRadius: 8,
                    border:
                      record?.[`${colKey}_leave_status`] === "4" ||
                      record?.[`${colKey}_isammended`] === "1"
                        ? "1px solid orange"
                        : record?.[`${colKey}_leave_status`] === "5"
                        ? "1px solid green"
                        : "",
                    padding: "3px 8px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "start",
                    fontWeight: 500,
                    cursor: "pointer",
                    whiteSpace: "wrap",
                    textAlign: "start",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCardRecord({
                      shiftid: record?.[`${colKey}_id`],
                      leavestatus: record?.[`${colKey}_leave_status`],
                      leavename: record?.[`${colKey}_leave_name`],
                      isammended: record?.[`${colKey}_isammended`],
                    });
                    setIsCardVisible(true);
                  }}
                >
                  {isHoliday && findShift?.isholiday === "no" ? (
                    <>
                      <span style={{ textAlign: "start" }}>
                        Holiday
                        <br></br>
                        {record?.[`${colKey}_code`] &&
                          `(${record?.[`${colKey}_code`]})`}
                      </span>
                    </>
                  ) : (
                    <>
                      {record?.[`${colKey}_leave_status`] === "4" ||
                      record?.[`${colKey}_leave_status`] === "5" ? (
                        <span className="d-flex">
                          <Badge
                            className="me-2"
                            color={
                              record?.[`${colKey}_leave_status`] === "4" ||
                              record?.[`${colKey}_isammended`] === "1"
                                ? "orange"
                                : "green"
                            }
                          />
                          <span style={{ textAlign: "start" }}>
                            {record?.[`${colKey}_leave_name`]}
                            <br />
                            {record?.[`${colKey}_code`] &&
                              `(${record?.[`${colKey}_code`]})`}
                          </span>
                        </span>
                      ) : (
                        <>
                          {" "}
                          {(findShift?.isweekend === "allsaturdayandsunday" &&
                            (daynumber === 0 || daynumber === 6)) ||
                          (findShift?.isweekend === "allsaturdays" &&
                            daynumber === 6) ||
                          (findShift?.isweekend === "allsundays" &&
                            daynumber === 0) ||
                          findShift?.isweekend === "alldays" ? (
                            <>
                              <span style={{ textAlign: "start" }}>
                                Weekend
                                <br></br>({record?.[`${colKey}_code`]})
                              </span>
                            </>
                          ) : (
                            <span>
                              {isHoliday
                                ? "Holiday"
                                : isMonthly
                                ? record?.[`${colKey}_code`]
                                : value}
                            </span>
                          )}
                        </>
                      )}
                    </>
                  )}

                  {!isPast &&
                    !isShiftTimeValid &&
                    !assignedColumnSelection &&
                    // (assignedColumnSelection ||
                    !showSelection &&
                    Menulist?.find(
                      (item) =>
                        item?.key === "manage" &&
                        item?.subMenu.find(
                          (subItem) =>
                            subItem?.key === "shift" && subItem?.permission.edit
                        )
                    ) && (
                      <div onClick={(e) => e.stopPropagation()}>
                        {
                          <Dropdown
                            overlay={getMenu(record, colKey)}
                            trigger={["click"]}
                          >
                            <MoreVertIcon
                              style={{
                                cursor: "pointer",
                                fontSize: 14,
                                color: "#000",
                              }}
                            />
                          </Dropdown>
                        }
                      </div>
                    )}

                  {!isPast &&
                    !isShiftTimeValid &&
                    assignedColumnSelection &&
                    value && (
                      <span
                        onClick={(e) => e.stopPropagation()} // Ensure parent click not triggered
                      >
                        <Checkbox
                          checked={selectedCells.some(
                            (cell) =>
                              cell.userid === record.userid &&
                              cell.colKey === colKey
                          )}
                          onChange={(e) => {
                            setShowSelection(false);
                            e.stopPropagation();
                            const cellKey = {
                              userid: record.userid,
                              colKey,
                              shifttitle: record?.[colKey],
                              shiftid: record?.[`${colKey}_id`],
                            };
                            if (e.target.checked) {
                              setSelectedCells((prev) => [...prev, cellKey]);
                            } else {
                              setSelectedCells((prev) =>
                                prev.filter(
                                  (cell) =>
                                    !(
                                      cell.userid === record.userid &&
                                      cell.colKey === colKey
                                    )
                                )
                              );
                            }
                          }}
                        />
                      </span>
                    )}
                </Tag>
              ) : (
                <>
                  <Button
                    shape="circle"
                    size="small"
                    style={{ color: "#2D53DA" }}
                    type="dashed"
                    disabled={
                      !Menulist?.find(
                        (item) =>
                          item?.key === "manage" &&
                          item?.subMenu.find(
                            (subItem) =>
                              subItem?.key === "shift" &&
                              subItem?.permission.create
                          )
                      ) ||
                      isPast ||
                      (showSelection && selectedType === "change") ||
                      showColumnSelection
                    }
                    onClick={() => {
                      const colKey = date.format("YYYY-MM-DD");
                      const cellRecord = {
                        ...record,
                        date: colKey,
                      };
                      setSelectedCell(cellRecord);
                      setIsAssignShift(true);
                    }}
                  >
                    +
                  </Button>
                  {showColumnSelection && !isPast && (
                    <Checkbox
                      style={{ position: "absolute", top: 10, right: 10 }}
                      checked={selectedCells.some(
                        (cell) =>
                          cell.userid === record.userid &&
                          cell.colKey === colKey
                      )}
                      onChange={(e) => {
                        const cellKey = {
                          userid: record.userid,
                          colKey,
                          shiftid: record?.[`${colKey}_id`],
                          shifttitle: record?.[colKey],
                        };
                        if (e.target.checked) {
                          setSelectedCells((prev) => [...prev, cellKey]);
                          setShowSelection(false);
                        } else {
                          setSelectedCells((prev) =>
                            prev.filter(
                              (cell) =>
                                !(
                                  cell.userid === record.userid &&
                                  cell.colKey === colKey
                                )
                            )
                          );
                        }
                      }}
                    />
                  )}
                </>
              )}
            </div>
          }
        </div>
      );
    },
    [shiftMap, leaveMap, currentTime, isMonthly]
  );

  const columns = [
    {
      title: "Employee",
      dataIndex: "fullname",
      fixed: "left",
      width: 180,
      render: (_, record) => (
        <Space>
          {record?.profileurl === null ||
          Array.isArray(record?.profileurl) ||
          record?.profileurl === "" ||
          exportLoader ? (
            <StyledAvatar size="default">
              {startCase(record?.fullname)?.charAt(0)}
            </StyledAvatar>
          ) : (
            <StyledAvatar src={record?.profileurl} size="default" />
          )}
          <Space direction="vertical" size={0}>
            <b style={{ fontWeight: 400, fontSize: "14px" }}>
              {record.fullname}
            </b>
            <small>{record.employeeid}</small>
          </Space>
        </Space>
      ),
    },
    ...days?.map((date) => ({
      title: (
        <>
          {isMonthly ? (
            <div className="text-center">
              <div className="d-flex justify-content-center gap-3">
                <div>
                  <div style={{ fontWeight: 400 }}>{date.date()}</div>
                  <div style={{ fontSize: 12, color: "#636980" }}>
                    {date.format("ddd")}
                  </div>
                </div>
                {assignedColumnSelection &&
                !dayjs(date).isBefore(today, "day") ? (
                  <Checkbox
                    className="mx-2"
                    checked={dataSource
                      .filter((emp) => {
                        const colKey = date.format("YYYY-MM-DD");
                        return !!emp[colKey] && isRowSelectable(emp, colKey);
                      })
                      .every((emp) =>
                        selectedCells.some(
                          (cell) =>
                            cell.userid === emp.userid &&
                            cell.colKey === date.format("YYYY-MM-DD")
                        )
                      )}
                    onChange={(e) => {
                      e.stopPropagation();
                      const colKey = date.format("YYYY-MM-DD");
                      if (e.target.checked) {
                        const newCells = dataSource
                          .filter((emp) =>
                            assignedColumnSelection
                              ? !!emp[colKey]
                              : !emp[colKey]
                          )
                          .map((emp) => ({
                            userid: emp.userid,
                            colKey,
                            shiftid: emp?.[colKey + "_id"],
                            shifttitle: emp?.[colKey],
                          }));
                        setSelectedCells((prev) => [
                          ...prev.filter((cell) => cell.colKey !== colKey),
                          ...newCells,
                        ]);
                        setShowSelection(false);
                      } else {
                        setSelectedCells((prev) =>
                          prev.filter((cell) => cell.colKey !== colKey)
                        );
                      }
                    }}
                  />
                ) : null}
                {showColumnSelection && !dayjs(date).isBefore(today, "day") ? (
                  <Checkbox
                    className="mx-2"
                    checked={dataSource
                      .filter((emp) => !emp[date.format("YYYY-MM-DD")])
                      .every((emp) =>
                        selectedCells.some(
                          (cell) =>
                            cell.userid === emp.userid &&
                            cell.colKey === date.format("YYYY-MM-DD")
                        )
                      )}
                    onChange={(e) => {
                      const colKey = date.format("YYYY-MM-DD");
                      if (e.target.checked) {
                        const newCells = dataSource
                          .filter((emp) => !emp[colKey])
                          .map((emp) => ({ userid: emp.userid, colKey }));
                        setSelectedCells((prev) => [
                          ...prev.filter((cell) => cell.colKey !== colKey),
                          ...newCells,
                        ]);
                        setShowSelection(false);
                      } else {
                        setSelectedCells((prev) =>
                          prev.filter((cell) => cell.colKey !== colKey)
                        );
                      }
                    }}
                  />
                ) : null}
              </div>
            </div>
          ) : (
            <>
              <div className="d-flex align-items-center justify-content-center">
                <div style={{ fontWeight: 400 }}>
                  {date.date()} -{" "}
                  <span style={{ color: "#636980" }}>{date.format("ddd")}</span>{" "}
                </div>
                {assignedColumnSelection &&
                !dayjs(date).isBefore(today, "day") ? (
                  <Checkbox
                    className="mx-2"
                    checked={dataSource
                      .filter((emp) => {
                        const colKey = date.format("YYYY-MM-DD");
                        return !!emp[colKey] && isRowSelectable(emp, colKey);
                      })
                      .every((emp) =>
                        selectedCells.some(
                          (cell) =>
                            cell.userid === emp.userid &&
                            cell.colKey === date.format("YYYY-MM-DD")
                        )
                      )}
                    onChange={(e) => {
                      const colKey = date.format("YYYY-MM-DD");
                      if (e.target.checked) {
                        const newCells = dataSource
                          .filter((emp) =>
                            assignedColumnSelection
                              ? !!emp[colKey]
                              : !emp[colKey]
                          )
                          .map((emp) => ({
                            userid: emp.userid,
                            colKey,
                            shiftid: emp?.[colKey + "_id"],
                            shifttitle: emp?.[colKey],
                          }));
                        setSelectedCells((prev) => [
                          ...prev.filter((cell) => cell.colKey !== colKey),
                          ...newCells,
                        ]);
                        setShowSelection(false);
                      } else {
                        setSelectedCells((prev) =>
                          prev.filter((cell) => cell.colKey !== colKey)
                        );
                      }
                    }}
                  />
                ) : null}
                {showColumnSelection && !dayjs(date).isBefore(today, "day") ? (
                  <Checkbox
                    className="mx-2"
                    checked={dataSource
                      .filter((emp) => !emp[date.format("YYYY-MM-DD")])
                      .every((emp) =>
                        selectedCells.some(
                          (cell) =>
                            cell.userid === emp.userid &&
                            cell.colKey === date.format("YYYY-MM-DD")
                        )
                      )}
                    onChange={(e) => {
                      const colKey = date.format("YYYY-MM-DD");
                      if (e.target.checked) {
                        const newCells = dataSource
                          .filter((emp) => !emp[colKey])
                          .map((emp) => ({
                            userid: emp.userid,
                            colKey,
                            shiftid: emp?.[colKey + "_id"],
                            shifttitle: emp?.[colKey],
                          }));
                        setSelectedCells((prev) => [
                          ...prev.filter((cell) => cell.colKey !== colKey),
                          ...newCells,
                        ]);
                        setShowSelection(false);
                      } else {
                        setSelectedCells((prev) =>
                          prev.filter((cell) => cell.colKey !== colKey)
                        );
                      }
                    }}
                  />
                ) : null}
              </div>
            </>
          )}
        </>
      ),
      dataIndex: date.format("YYYY-MM-DD"),
      width: dateColumnWidth,
      align: "center",
      className: dayjs(date).isBefore(today, "day") ? "past_columns" : "",
      render: (value, record) => renderCell(value, record, date),
    })),
  ];

  const renderDateRange = () => {
    const start = isMonthly
      ? currentDate.startOf("month").format("MMMM YYYY")
      : `${currentDate.startOf("week").format("D MMM")} - ${currentDate
          .endOf("week")
          .format("D MMM YYYY")}`;
    return start;
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, selectedRows) => {
      const userids = selectedRows.map((row) => row.userid);
      setSelectedRowKeys(keys);
      setSelectedRowIds(userids);
      setShowColumnSelection(false);
      setAssignedColumnSelection(false);
    },
    columnWidth: 50,
  };

  const handleExportPDF = async () => {
    setExportLoader(true);

    const tableWrapper = document.getElementById("shift-table-export");
    if (!tableWrapper) return;

    // Store all original styles
    const fixedLeft = tableWrapper.querySelector(".ant-table-fixed-left");
    const fixedRight = tableWrapper.querySelector(".ant-table-fixed-right");
    const originalDisplayLeft = fixedLeft?.style.display;
    const originalDisplayRight = fixedRight?.style.display;

    if (fixedLeft) fixedLeft.style.display = "none";
    if (fixedRight) fixedRight.style.display = "none";

    // Add temporary style to hide ALL scrollbars and borders
    const style = document.createElement("style");
    style.id = "hide-scrollbars-temp";
    style.innerHTML = `
    #shift-table-export,
    #shift-table-export *,
    #shift-table-export .ant-table,
    #shift-table-export .ant-table-container,
    #shift-table-export .ant-table-body,
    #shift-table-export .ant-table-content,
    #shift-table-export .ant-table-scroll {
      overflow: hidden !important;
      scrollbar-width: none !important;
      -ms-overflow-style: none !important;
      max-width: none !important;
      max-height: none !important;
    }
    #shift-table-export *::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }
    #shift-table-export .ant-table-ping-right::after,
    #shift-table-export .ant-table-ping-left::after,
    #shift-table-export .ant-table-ping-right::before,
    #shift-table-export .ant-table-ping-left::before,
    #shift-table-export .ant-table-container::before,
    #shift-table-export .ant-table-container::after {
      display: none !important;
      box-shadow: none !important;
    }
  `;
    document.head.appendChild(style);

    const originalPadding = tableWrapper.style.padding;
    const originalWidth = tableWrapper.style.width;
    const originalMaxWidth = tableWrapper.style.maxWidth;

    tableWrapper.style.padding = "20px";
    tableWrapper.style.width = "fit-content";
    tableWrapper.style.maxWidth = "none";

    await new Promise((res) => setTimeout(res, 30));

    const rows = Array.from(
      tableWrapper.querySelectorAll(".ant-table-tbody tr")
    );
    const rowsPerPage = 20; // Increased back to 20 for fewer pages

    if (rows.length === 0) {
      message.warning("No data available to export.");
      document.getElementById("hide-scrollbars-temp")?.remove();
      setExportLoader(false);
      return;
    }

    const pdf = new jsPDF("l", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const padding = 10;

    const totalPages = Math.ceil(rows.length / rowsPerPage);

    // Process in optimized batches
    for (let i = 0; i < totalPages; i++) {
      const startIdx = i * rowsPerPage;
      const endIdx = Math.min((i + 1) * rowsPerPage, rows.length);

      // Clone and prepare element
      const clonedWrapper = tableWrapper.cloneNode(true);
      clonedWrapper.style.cssText = `
      position: absolute;
      left: -9999px;
      top: 0;
      background: #fff;
      padding: 20px;
      width: fit-content;
      max-width: none;
      overflow: hidden;
    `;

      // Remove fixed columns
      clonedWrapper.querySelector(".ant-table-fixed-left")?.remove();
      clonedWrapper.querySelector(".ant-table-fixed-right")?.remove();

      // Hide rows efficiently
      const clonedRows = clonedWrapper.querySelectorAll(".ant-table-tbody tr");
      for (let idx = 0; idx < clonedRows.length; idx++) {
        clonedRows[idx].style.display =
          idx >= startIdx && idx < endIdx ? "" : "none";
      }

      document.body.appendChild(clonedWrapper);

      // Optimized html2canvas settings
      const canvas = await html2canvas(clonedWrapper, {
        backgroundColor: "#ffffff",
        useCORS: true,
        scale: 1.3, // Balanced quality/speed
        logging: false,
        allowTaint: true,
        imageTimeout: 0,
        removeContainer: false,
      });

      document.body.removeChild(clonedWrapper);

      // Use JPEG for smaller file size
      const imgData = canvas.toDataURL("image/jpeg", 0.88);

      const availableWidth = pageWidth - padding * 2;
      const availableHeight = pageHeight - padding * 2;

      const scale = Math.min(
        availableWidth / canvas.width,
        availableHeight / canvas.height
      );

      const imgWidth = canvas.width * scale;
      const imgHeight = canvas.height * scale;

      if (i > 0) pdf.addPage();

      pdf.addImage(
        imgData,
        "JPEG",
        (pageWidth - imgWidth) / 2,
        (pageHeight - imgHeight) / 2,
        imgWidth,
        imgHeight,
        undefined,
        "FAST" // Use FAST compression
      );

      // Nullify canvas immediately
      canvas.width = 1;
      canvas.height = 1;
    }

    // Restore everything
    tableWrapper.style.padding = originalPadding || "";
    tableWrapper.style.width = originalWidth || "";
    tableWrapper.style.maxWidth = originalMaxWidth || "";

    if (fixedLeft) fixedLeft.style.display = originalDisplayLeft ?? "";
    if (fixedRight) fixedRight.style.display = originalDisplayRight ?? "";

    document.getElementById("hide-scrollbars-temp")?.remove();

    pdf.save("shift-schedule.pdf");
    setExportLoader(false);
  };

  useEffect(() => {
    handleFormChange();
  }, [userList]);

  useEffect(() => {
    getLeaveList();
    getAssignedShiftList();
    getHolidayList();
  }, [currentDate, isMonthly]);

  useEffect(() => {
    getShiftList();
  }, []);

  const footerStyle = {
    position: "sticky",
    bottom: -25,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "20px -24px -20px -20px",
    zIndex: 10,
  };

  return (
    <ShiftCalendarWrap>
      <Spin spinning={exportLoader}>
        <div className="header-view">
          <h5 className="">Shift</h5>
          <div className="header-buttons">
            <Button
              type="link"
              className="change-view"
              disabled={
                showSelection || showColumnSelection || assignedColumnSelection
              }
              onClick={() => history.push("shift")}
            >
              Shift View
            </Button>
            <ButtonOutlined
              disabled={
                showSelection || showColumnSelection || assignedColumnSelection
              }
              onClick={handleExportPDF}
            >
              Export PDF File
            </ButtonOutlined>
            <ButtonFilled
              type="primary"
              disabled={
                !Menulist?.find(
                  (item) =>
                    item?.key === "manage" &&
                    item?.subMenu.find(
                      (subItem) =>
                        subItem?.key === "shift" && subItem?.permission.create
                    )
                ) ||
                showSelection ||
                showColumnSelection ||
                assignedColumnSelection
              }
              onClick={() =>
                history.push("addshift", { shiftColors: shiftColor })
              }
            >
              + Add Shift
            </ButtonFilled>
          </div>
        </div>
        <Form
          form={form}
          layout="vertical"
          className="mt-2"
          onValuesChange={handleFormChange}
        >
          <Row gutter={12} className="g-3 mb-2">
            <Col xs={24} sm={24} md={18} lg={16} xl={12}>
              Total People: {filterShiftList?.length}
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} ref={containerRef}>
              <DropdownCheckBox
                name="people"
                label="Search People"
                options={uniqBy(
                  userList.map((item) => {
                    return {
                      label: item?.fullname,
                      value: item?.userid,
                    };
                  }),
                  "value"
                )}
                form={form}
                handleFormChange={handleFormChange}
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={6} ref={containerRef}>
              <DropdownCheckBox
                name="department"
                label="Department"
                options={uniqBy(
                  departmentList?.map((item) => {
                    return {
                      label: item?.department_name,
                      value: item?.department_id,
                    };
                  }),
                  "value"
                )}
                form={form}
                handleFormChange={handleFormChange}
              />
            </Col>

            {/* <Col xs={24} sm={24} md={12} lg={8} xl={6} ref={containerRef}>
              <DropdownCheckBox
                name="location"
                label="Location"
                options={uniqBy(
                  locationList
                    ?.filter((item) => item?.login_from_anywhere !== 1)
                    .map((item) => {
                      return {
                        label: item?.location_name,
                        value: item?.location_id,
                      };
                    }),
                  "value"
                )}
                form={form}
                handleFormChange={handleFormChange}
              />
            </Col>  */}
          </Row>
        </Form>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
              alignItems: "center",
            }}
          >
            <div
              style={{
                background: "#E2E2E8",
                borderRadius: 4,
                padding: "10px",
              }}
            >
              <span>Weekly</span>
              <Switch
                className="mx-2"
                disabled={
                  showSelection ||
                  showColumnSelection ||
                  assignedColumnSelection
                }
                checked={isMonthly}
                onChange={handleToggle}
              />
              <span>Monthly</span>
            </div>
            <div
              style={{
                background: "#E2E2E8",
                borderRadius: 4,
                padding: "10px",
              }}
            >
              <CalendarOutlined className="mx-2" />
              <b>{renderDateRange()}</b>
              <LeftOutlined onClick={handlePrev} className="mx-2" />
              <RightOutlined onClick={handleNext} />
            </div>
          </div>
          <Space wrap>
            {/* <div
              style={{
                background: "#E2E2E8",
                borderRadius: 4,
                padding: "10px",
              }}
            >
              <span>Weekly</span>
              <Switch
                className="mx-2"
                disabled={
                  showSelection ||
                  showColumnSelection ||
                  assignedColumnSelection
                }
                checked={isMonthly}
                onChange={handleToggle}
              />
              <span>Monthly</span>
            </div>
            <div
              className="mx-2"
              style={{
                background: "#E2E2E8",
                borderRadius: 4,
                padding: "10px",
              }}
            >
              <CalendarOutlined className="mx-2" />
              <b>{renderDateRange()}</b>
              <LeftOutlined onClick={handlePrev} className="mx-2" />

              <RightOutlined onClick={handleNext} />
            </div> */}
          </Space>
          <Space></Space>
          <Space>
            <Button
              type="link"
              className="change-view"
              onClick={() => setIsCloneShift(true)}
              disabled={
                !Menulist?.find(
                  (item) =>
                    item?.key === "manage" &&
                    item?.subMenu.find(
                      (subItem) =>
                        subItem?.key === "shift" && subItem?.permission.edit
                    )
                ) ||
                showSelection ||
                showColumnSelection ||
                assignedColumnSelection
              }
            >
              Clone Shift
            </Button>
            <Button
              type="link"
              className="change-view"
              disabled={
                !Menulist?.find(
                  (item) =>
                    item?.key === "manage" &&
                    item?.subMenu.find(
                      (subItem) =>
                        subItem?.key === "shift" && subItem?.permission.edit
                    )
                ) ||
                showSelection ||
                showColumnSelection ||
                assignedColumnSelection
              }
              onClick={() => {
                setAssignedColumnSelection(true);
                setShowSelection(true);
                setSetlectedType("change");
              }}
            >
              Change Shift
            </Button>
            <Button
              type="link"
              className="change-view"
              disabled={
                !Menulist?.find(
                  (item) =>
                    item?.key === "manage" &&
                    item?.subMenu.find(
                      (subItem) =>
                        subItem?.key === "shift" && subItem?.permission.edit
                    )
                ) ||
                showSelection ||
                showColumnSelection ||
                assignedColumnSelection
              }
              onClick={() => {
                setShowColumnSelection(true);
                setShowSelection(true);
                setSetlectedType("assign");
              }}
            >
              Assign Shift
            </Button>
          </Space>
        </div>

        <div id="shift-table-export">
          <Table
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            rowSelection={showSelection ? rowSelection : null}
            // scroll={{ x: "max-content" }}
            rowClassName={() => "custom-table-row"}
            scroll={{
              x: fixedEmployeeWidth + dateColumnWidth * days.length, // important
            }}
            bordered
          />
        </div>

        {(showColumnSelection || showSelection || assignedColumnSelection) && (
          <div style={footerStyle}>
            <ButtonOutlined
              onClick={() => {
                setSelectedCells([]);
                setSelectedRowKeys([]);
                setShowColumnSelection(false);
                setShowSelection(false);
                setAssignedColumnSelection(false);
                setSetlectedType("");
                handleCancel();
              }}
            >
              Cancel
            </ButtonOutlined>
            <ButtonFilled
              type="primary"
              htmlType="submit"
              disabled={
                selectedCells?.length === 0 && selectedRowIds?.length === 0
              }
              onClick={() => {
                if (selectedType === "change") {
                  setIsChangeShift(true);
                } else if (selectedType === "assign") {
                  setIsAssignShift(true);
                }
              }}
            >
              Next
            </ButtonFilled>
          </div>
        )}
        {isCloneShift && (
          <CloneShift open={isCloneShift} setOpen={setIsCloneShift} />
        )}
        {isAssignShift && (
          <AssignShift
            open={isAssignShift}
            setOpen={setIsAssignShift}
            selectedCell={selectedCell}
            getAssignedShiftList={getAssignedShiftList}
            shiftList={shiftList}
            selectedRowIds={selectedRowIds}
            isMonthly={isMonthly}
            selectedCells={selectedCells}
            handleCancel={handleCancel}
            selectedDate={currentDate}
            currentTime={currentTime}
            userTimeZone={userTimeZone}
            dataSource={dataSource}
          />
        )}
        {isChangeShift && (
          <ChangeShift
            open={isChangeShift}
            setOpen={setIsChangeShift}
            selectedCell={selectedCell}
            shiftList={shiftList}
            getAssignedShiftList={getAssignedShiftList}
            selectedRowIds={selectedRowIds}
            handleCancel={handleCancel}
            selectedCells={selectedCells}
            dataSource={dataSource}
            currentDate={currentDate}
            currentTime={currentTime}
            userTimeZone={userTimeZone}
            isMonthly={isMonthly}
          />
        )}

        <DayInfo
          open={isCardVisible}
          setOpen={setIsCardVisible}
          data={shiftList?.find((val) => val?.shift_id === cardRecord?.shiftid)}
          shiftList={shiftList}
          record={cardRecord}
        />
      </Spin>
    </ShiftCalendarWrap>
  );
};

export default ShiftCalendar;
